const EthiopiaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111390)">
      <path
        d="M0 20.0003C0 22.4469 0.440078 24.7903 1.24406 26.957L20 28.6959L38.7559 26.957C39.56 24.7903 40 22.4468 40 20.0003C40 17.5874 39.5726 15.2744 38.7895 13.1327L20 11.3047L1.21047 13.1328C0.427422 15.2744 0 17.5874 0 20.0003H0Z"
        fill="#FFDA44"
      />
      <path
        d="M19.9997 40.0005C28.599 40.0005 35.9298 34.573 38.7557 26.957H1.24365C4.06951 34.573 11.4004 40.0005 19.9997 40.0005Z"
        fill="#D80027"
      />
      <path
        d="M19.9997 0C11.4004 0 4.06951 5.4275 1.24365 13.0435H38.7558C35.9298 5.4275 28.599 0 19.9997 0Z"
        fill="#6DA544"
      />
      <path
        d="M20.0003 29.565C25.283 29.565 29.5655 25.2825 29.5655 19.9998C29.5655 14.7171 25.283 10.4346 20.0003 10.4346C14.7176 10.4346 10.4351 14.7171 10.4351 19.9998C10.4351 25.2825 14.7176 29.565 20.0003 29.565Z"
        fill="#0052B4"
      />
      <path
        d="M19.9975 12.5928L21.7242 17.907H27.3209L22.7913 21.1914L24.5317 26.5214L19.9975 23.2214L15.4703 26.5154L17.2036 21.1914L12.6782 17.907H18.2708L19.9975 12.5928Z"
        fill="#FFDA44"
      />
      <path
        d="M26.8846 21.3221L21.4068 19.5421L24.7922 14.8827L23.3853 13.8604L19.9998 18.52L16.6145 13.8604L15.2075 14.8826L18.5928 19.5424L13.1152 21.322L13.6526 22.9761L19.1304 21.1964V26.9559H20.8695V21.1963L26.347 22.9761L26.8846 21.3221Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111390">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default EthiopiaSvg;
